import type {SyncIntegration} from '@cohort/merchants/apps';
import SalesforceSyncConfigComponent from '@cohort/merchants/apps/salesforce/sync/SyncConfigComponent';
import type {SalesforceSyncStruct} from '@cohort/shared/apps/salesforce/sync';
import {SalesforceSyncIntegrationSpec} from '@cohort/shared/apps/salesforce/sync';

export const SalesforceSyncIntegration: SyncIntegration<SalesforceSyncStruct> = {
  spec: SalesforceSyncIntegrationSpec,
  syncConfigComponent: SalesforceSyncConfigComponent,
};
